import { defaultTarjetaEmergencia } from './state'

export function setTarjetaEmergencia(state, tarjeta) {
    state.selectedTarjetaEmergencia = tarjeta
}
export function setIdTarjetaEmergencia(state, id) {
    state.selectedTarjetaEmergencia.id = id;
}

export function accionTarjeta(state, accion) {
    state.accionTarj = accion;
}

export function activaTarjeta(state, ver) {
    state.verTarjeta = ver;
}

export function tarjetaEmergenciaError(state, error) {
    state.errorTarj = error
}
export function resetSelectedTarjetaEmergencia(state) {
    Object.assign(state.selectedTarjetaEmergencia, defaultTarjetaEmergencia())
}

/**
 * Función para obtener la información de la asignación por empresa y producto
 * @param json data Información de la asignación
 */
export function setAsignacionTarjetasEmergencia(state, data) {
    if (data !== null) {
        state.asignacionTarjetaEmergencia.id_empresa = data.id_empresa;
        state.asignacionTarjetaEmergencia.id_producto = data.id_producto;
        state.asignacionTarjetaEmergencia.pdf = process.env.VUE_APP_API_URL+data.pdf;
        state.asignacionTarjetaEmergencia.estado = data.estado;
        state.asignacionTarjetaEmergencia.date = data.updated_at
    }
}

export function setAcgih(state, data) {
  if (data !== null) {
    state.selectedTarjetaEmergencia.parametrosexposicionacgih = data;
  }
}

